export const getPayersFilters = state => state.payers.payersFilters;

export const getPayersGridSortCriteria = state => state.payers.payersGridSortCriteria;
